import Route from '@ember/routing/route';

export default class CreateRoute extends Route {
  model() {
    return this.modelFor('admin.bookings');
  }

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.cleanupEvent();
    }
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.setupEvent();
  }
}
